import { createTypes } from 'reduxsauce';

export default createTypes(
  `
UPDATE_EXTEND_VIGNETTE_ROUTE
UPDATE_BUY_VIGNETTE_ROUTE
`,
  {},
);
